import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import layout_vn from "./locales/vn/layout.translation.json";
import layout_en from "./locales/en/layout.translation.json";

// okr
import okr_vn from "./locales/vn/okr.translation.json";
import okr_en from "./locales/en/okr.translation.json";

//gperformance
import kpi_vn from "./locales/vn/gperformance.translation.json";
import kpi_en from "./locales/en/gperformance.translation.json";

//g-process
import gprocess_vn from "./locales/vn/gprocess.translation.json";
import gprocess_en from "./locales/en/gprocess.translation.json";
import gprocess_vn_message from "./locales/vn/message.translation.json";
import gprocess_en_message from "./locales/en/message.translation.json";

//g-ticket
import gticket_en from "./locales/en/gticket.translation.json";
import gticket_vn from "./locales/vn/gticket.translation.json";

//system-management
import systemmanagement_vn from "./locales/vn/systemmanagement.translation.json";
import systemmanagement_en from "./locales/en/systemmanagement.translation.json";

import mission_vn from "./locales/vn/mission.translation.json";
import mission_en from "./locales/en/mission.translation.json";

import task_evaluate_en from "./locales/en/task-evaluation.translation.json";
import task_evaluate_vn from "./locales/vn/task-evaluation.translation.json";

import dashboard_vn from "./locales/vn/dashboard.translation.json";
import dashboard_en from "./locales/en/dashboard.translation.json";

import message_vn from "./locales/vn/message.translation.json";
import message_en from "./locales/en/message.translation.json";

import main_user_evaluate_en from "./locales/en/main-user-evaluation.translation.json";
import main_user_evaluate_vn from "./locales/vn/main-user-evaluation.translation.json";

import management_timesheet_en from "./locales/en/management-timesheet.translation.json";
import management_timesheet_vn from "./locales/vn/management-timesheet.translation.json";
import information_vn from "./locales/vn/information.translation.json";
import information_en from "./locales/en/information.translation.json";

// survey-form
import survey_en from "./locales/en/survey.translation.json";
import survey_vn from "./locales/vn/survey.translation.json";

// magic-mirror (US_06 báo cáo cá nhân)
import magicMirror_en from "./locales/en/magicmirror.translation.json";
import magicMirror_vn from "./locales/vn/magicmirror.translation.json";

// g-process report (báo cáo yêu cầu / nhiệm vụ)
import report_en from "./locales/en/report.translation.json";
import report_vn from "./locales/vn/report.translation.json";

import { LANGUAGES } from "./helpers/constant";

const resources = {
  en: {
    layout: layout_en,
    okr: okr_en,
    systemManagement: systemmanagement_en,
    gperformance: kpi_en,
    gprocess: gprocess_en,
    gmessage: gprocess_en_message,
    mission: mission_en,
    task_evaluate: task_evaluate_en,
    main_user_evaluate: main_user_evaluate_en,
    gticket: gticket_en,
    dashboard: dashboard_en,
    message: message_en,
    management_timesheet: management_timesheet_en,
    information: information_en,
    survey: survey_en,
    magicMirror: magicMirror_en,
    report: report_en,
  },
  vn: {
    layout: layout_vn,
    okr: okr_vn,
    systemManagement: systemmanagement_vn,
    gperformance: kpi_vn,
    gprocess: gprocess_vn,
    gmessage: gprocess_vn_message,
    mission: mission_vn,
    task_evaluate: task_evaluate_vn,
    main_user_evaluate: main_user_evaluate_vn,
    gticket: gticket_vn,
    dashboard: dashboard_vn,
    message: message_vn,
    management_timesheet: management_timesheet_vn,
    information: information_vn,
    survey: survey_vn,
    magicMirror: magicMirror_vn,
    report: report_vn,
  },
};

i18n
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    lng: LANGUAGES.VN,
    fallbackLng: LANGUAGES.VN,
    resources,
    interpolation: {
      escapeValue: false, // not needed for react!!
    },
  });

export default i18n;
